import { UX_REDIRECT } from "../actions/ux";

const initialState = {
    redirectTo: null
};

export default function uxReducer(ux=initialState, action) {
    switch (action.type)
    {
        case UX_REDIRECT:
            return {
                ...ux,
                redirectTo: action.redirectTo
            };
        default:
            break;
    }
    return ux;
}